import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaComissoes } from '@/features/relatorio/page/venda/comissoes/RelatorioVendaComissoes';

export const Route = createFileRoute('/a/relatorio/venda/comissoes')({
    component: RelatorioVendaComissoes,
});
